module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "modal",
    class: {
      'is-active': showModal
    },
    attrs: {
      "id": "myModal"
    }
  }, [_m(0), " ", _h('div', {
    staticClass: "modal-card"
  }, [_h('header', {
    staticClass: "modal-card-head"
  }, [_m(1), " ", _h('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        showModal = false
      }
    }
  })]), " ", _m(2), " ", _h('footer', {
    staticClass: "modal-card-foot"
  }, [_h('center', [_h('a', {
    staticClass: "button is-primary",
    on: {
      "click": showResult
    }
  }, ["Save changes"]), " ", _h('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        showModal = false
      }
    }
  }, ["Cancel"])])])])])
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    staticClass: "modal-background"
  })
}},function (){with(this) {
  return _h('p', {
    staticClass: "modal-card-title"
  }, ["Crop your image"])
}},function (){with(this) {
  return _h('section', {
    staticClass: "modal-card-body has-text-centered"
  }, [_h('div', {
    staticClass: "container"
  }, [_h('div', {
    staticClass: "cropper-area"
  })])])
}}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c75f9350!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 126
// module chunks = 2